import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "search",
    "selection",
    "noneSelected",
    "chip",
    "chipLabel",
    "list",
    "option",
    "otherOption",
    "radio",
    "hiddenSelection",
    "noResults",
    "customName",
  ];

  static values = { other: String };

  connect() {
    this.syncFromSelection();
    this.filter();
  }

  filter() {
    const query = this.hasSearchTarget
      ? this.searchTarget.value.trim().toLowerCase()
      : "";

    let visibleCount = 0;

    this.optionTargets.forEach((option) => {
      if (this.isOtherOption(option)) return;

      const haystack = option.dataset.eventSearch || "";
      const matches = query === "" || haystack.includes(query);
      option.classList.toggle("d-none", !matches);
      if (matches) visibleCount += 1;
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("d-none", visibleCount > 0);
    }
  }

  pick(event) {
    const radio = event.target;
    if (!radio.checked) return;

    this.hiddenSelectionTarget.value = radio.value;
    this.hiddenSelectionTarget.dispatchEvent(
      new Event("change", { bubbles: true })
    );
    this.syncFromSelection();
  }

  customNameChanged() {
    if (this.hiddenSelectionTarget.value !== this.otherValue) return;
    this.updateSelectionDisplay();
  }

  syncFromSelection() {
    const value = this.hiddenSelectionTarget.value;

    this.radioTargets.forEach((radio) => {
      const checked = radio.value === value;
      radio.checked = checked;
      const option = radio.closest(".rb-staff-option");
      if (option) option.classList.toggle("is-selected", checked);
    });

    this.updateSelectionDisplay();
  }

  updateSelectionDisplay() {
    const value = this.hiddenSelectionTarget.value;
    const hasSelection = Boolean(value);

    if (this.hasSelectionTarget) {
      this.selectionTarget.classList.toggle("d-none", !hasSelection);
    }

    if (this.hasNoneSelectedTarget) {
      this.noneSelectedTarget.classList.toggle("d-none", hasSelection);
    }

    if (!hasSelection || !this.hasChipLabelTarget) return;

    let label = "Selected";

    if (value === this.otherValue) {
      const name = this.hasCustomNameTarget
        ? this.customNameTarget.value.trim()
        : "";
      label = name || "Other — enter name below";
    } else {
      const selected = this.radioTargets.find((radio) => radio.checked);
      label = selected?.dataset.eventName || "Selected";
    }

    this.chipLabelTarget.textContent = label;

    if (this.hasChipTarget) {
      this.chipTarget.title = label;
    }
  }

  isOtherOption(option) {
    return this.hasOtherOptionTarget && option === this.otherOptionTarget;
  }
}
